const CONTENT_STYLE = {
  backgroundColor: "hsl(var(--card))",
  border: "1px solid hsl(var(--border))",
  borderRadius: 8,
  fontSize: 12,
  color: "hsl(var(--foreground))",
  maxWidth: "min(420px, calc(100vw - 24px))",
  // The box grows with its rows instead of scrolling internally (Yuanyuan
  // could not operate the old scrollbar). The portal takes no pointer events,
  // so an inner scrollbar would be unreachable anyway: past the viewport cap
  // the list clips, which needs ~45+ entities on one screen.
  maxHeight: "calc(100vh - 24px)",
  overflow: "hidden",
  padding: "10px 12px",
};

const HEADER_STYLE = {
  display: "flex",
  justifyContent: "space-between",
  gap: 16,
  marginBottom: 8,
  fontWeight: 600,
  whiteSpace: "nowrap",
};

// Tooltip body shared by the hero and scope charts (R09 item 4): one line per
// entity, pre-sorted biggest first by the caller, with the top row bolded so
// the highest emitter reads first.
const SortedTooltipContent = ({
  label,
  totalLabel,
  rows,
  rankTop = false,
  footerLabel = null,
}) => (
  <div style={CONTENT_STYLE}>
    <div style={HEADER_STYLE}>
      <span>{label}</span>
      {totalLabel ? (
        <span
          style={{
            color: "hsl(var(--muted-foreground))",
            fontWeight: 500,
          }}
        >
          {totalLabel}
        </span>
      ) : null}
    </div>
    <div style={{ display: "flex", flexDirection: "column", gap: 5 }}>
      {rows.map((row, idx) => (
        <div
          key={row.key}
          style={{
            display: "flex",
            alignItems: "center",
            gap: 7,
            minWidth: 0,
            fontWeight: rankTop && idx === 0 ? 700 : 400,
            color: row.color || "hsl(var(--foreground))",
          }}
        >
          <span
            style={{
              width: 9,
              height: 9,
              flex: "0 0 auto",
              borderRadius: 2,
              backgroundColor: row.color || "hsl(var(--foreground))",
            }}
          />
          <span
            style={{
              minWidth: 0,
              // Wrap long names instead of ellipsizing: the box takes no
              // pointer events, so a title-attribute fallback would be
              // unreachable by hover.
              overflowWrap: "anywhere",
            }}
          >
            {row.name}
          </span>
          <span
            style={{
              marginLeft: "auto",
              paddingLeft: 14,
              whiteSpace: "nowrap",
              fontVariantNumeric: "tabular-nums",
            }}
          >
            {row.valueLabel}
          </span>
        </div>
      ))}
    </div>
    {footerLabel ? (
      <div
        style={{
          marginTop: 8,
          paddingTop: 6,
          borderTop: "1px solid hsl(var(--border))",
          color: "hsl(var(--muted-foreground))",
          fontSize: 11,
        }}
      >
        {footerLabel}
      </div>
    ) : null}
  </div>
);

export default SortedTooltipContent;
